import { PrivateInterceptorsPR } from "../../../Base/interceptors/PrivateinterceptorsPR";


export const getLisEvaluacion = async () => {
   return await PrivateInterceptorsPR('RRHH/Evaluacion/', 'GET')
}

export const getAllLisEvaluacion = async () => {
   return await PrivateInterceptorsPR('RRHH/Evaluacion/allList', 'GET')
}
export const getEvaluacion = async (IdEvaluacion) => {
   return await PrivateInterceptorsPR(`RRHH/Evaluacion/get/${IdEvaluacion}`, 'GET')
}

export const getEvaluacionCREAR = async (idpersonal) => {
   return await PrivateInterceptorsPR(`RRHH/Evaluacion/getCREAR/${idpersonal}`, 'GET')
}

export const guardarEvaluacionPersonal = async (body) => {
   return await PrivateInterceptorsPR('RRHH/Evaluacion/save', 'POST',body)
}
export const editarEvaluacionPersonal = async (body) => {
   return await PrivateInterceptorsPR('RRHH/Evaluacion/update', 'POST',body)
}

export const cambiarPermisoEvaluacionSupervisor = async (body) => {
   return await PrivateInterceptorsPR('RRHH/Evaluacion/chagePermisoSupervisor', 'POST', body)
}


export const cambiarPermisoEvaluacionRRHH = async (body) => {
   return await PrivateInterceptorsPR('RRHH/Evaluacion/chagePermisoRRHH', 'POST', body)
}


export const cambiarPermisoEvaluacionPlanta = async (body) => {
   return await PrivateInterceptorsPR('RRHH/Evaluacion/chagePermisoPlanta', 'POST', body)
}

export const cancelarEvaluacion = async (body) => {
   return await PrivateInterceptorsPR('RRHH/Evaluacion/cancelarEvaluacion', 'POST', body)
}

export const getPerfilesPersonal = async () => {
   return await PrivateInterceptorsPR('RRHH/Evaluacion/getPerfiles', 'GET')
}

export const getPerfilesPersonalCREAR = async (posicion) => {
   return await PrivateInterceptorsPR('RRHH/Evaluacion/getPerfilesCrear', 'POST', {posicion})

}

